import React, { useContext, ReactNode } from 'react';
import { Route, Redirect } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import Engagement from '../Social/Social';
import ShortFormVideo from '../Social/ShortFormVideo';

import { socialSubTopics } from 'topics';
import TopicFilters from 'components/TopicFilters/TopicFilters';
import { EntityContext } from 'context/entityContext';

const VersionSocial: React.FC<any> = (props) => {
  const { match, pathPrefix } = props;
  const { entityId, parentEntityId } = match.params;

  const { compareMode, topic } = useContext(EntityContext);

  return (
    <>
      <SubNavigation topic="social" variants={socialSubTopics} />
      <TopicFilters topic={topic[1] || topic[0]} compareMode={compareMode} />

      <Route
        exact
        path={`${pathPrefix}/track/${parentEntityId}/version/${entityId}/social/engagement`}
        render={(): ReactNode => <Engagement />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${parentEntityId}/version/${entityId}/social/shortFormVideo`}
        render={(): ReactNode => <ShortFormVideo />}
      />
      <Redirect
        exact
        from={`${pathPrefix}/track/${parentEntityId}/version/${entityId}/social/linkfire`}
        to={`${pathPrefix}/track/${parentEntityId}/version/${entityId}/social/shortFormVideo`}
      />
    </>
  );
};

export default VersionSocial;
